import { BaseModel } from './index';
import { BOMStatusEnum } from '../lib/enums';

export interface BillOfMaterialList {
  id: string;
  logRevisionId: string;
  createdBy: string;
  updatedBy: string;
  code: string;
  timeCreated: string;
  timeUpdated: string;
  active: boolean;
  dateEntry: string;
  requiredDate: string;
  dateshipment: string;
  revision: string;
  pono: string;
  buyercode: string;
  preparedBy: string;
  status: BOMStatusEnum;
}

export interface BillOfMaterialRecord {
  files?: any;
  id: string;
  logRevisionId: string;
  createdBy: string;
  updatedBy: string;
  code: string;
  timeCreated: string;
  timeUpdated: string;
  active: boolean;
  dateEntry: string;
  requiredDate: string;
  dateshipment: string;
  approvedBy?: string;
  pono: string;
  revision: string;
  buyercode: string;
  preparedBy: string;
  status: BOMStatusEnum;
  proderno: string;
  remarks: string;
  details: Details[];
}

export interface Details {
  id: string;
  logRevisionId: string;
  createdBy: string;
  updatedBy: string;
  timeCreated: string;
  timeUpdated: string;
  active: boolean;
  setPackingNo: string;
  sku: string;
  processGroup: string;
  brand: string;
  size: string;
  product: BaseModel;
  materialCode?: string;
  materialName?: string;
  unit?: string;
  quantity: number;
  purchaseUom: BaseModel;
  defaultUom: BaseModel;
  status: string;
  mrNo: string;
  proderNo: string;
}

export interface BillOfMaterialDetailList {
  id: string;
  logRevisionId: string;
  createdBy: string;
  updatedBy: string;
  timeCreated: string;
  timeUpdated: string;
  active: boolean;
  setPackingNo: string;
  sku: string;
  processGroup: string;
  brand: string;
  size: string;
  used: string;
  product: BaseModel;
  quantity: number;
  purchaseUom: BaseModel;
  status: BOMStatusEnum;
  mrNo: string;
  proderNo: string;
}

export interface BillOfMaterialFilter {
  from: string | null;
  to: string | null;
  proder?: string | null | undefined;
  sku?: string | null | undefined;
  status?: string | null | undefined;
  datepicker?: (string | null)[];
}

export const BOMNextStatus = (prStatus?: BOMStatusEnum | undefined) => {
  let newStatus: any;
  switch (prStatus) {
    case 'CONFIRM':
      newStatus = 'APPROVED';
      break;
    case 'APPROVED':
      newStatus = 'READY';
      break;
    case 'READY':
      newStatus = 'DONE';
      break;
    default:
      newStatus = prStatus;
      break;
  }
  return newStatus;
};

export interface BOMStatusForm {
  status: string;
  remarks: string;
}

export interface BOMReportPDMops {
  header: PDMopsHeader;
  poDetails: PDMopsPODetail[];
  materialDetails: PDMopsMaterialDetail[];
}

export interface PDMopsHeader {
  id: string;
  logRevisionId: string;
  createdBy: string;
  updatedBy: string;
  timeCreated: string;
  timeUpdated: string;
  active: boolean;
  proderno: string;
  preparedDate: string;
  preparedBy: string;
  buyerCode: string;
  dateshipment: string;
}

export interface PDMopsPODetail {
  id: string;
  proderNo: string;
  pono: string;
  setPackingNo: string;
  skuDescription: string;
  skuNumber: string;
  size: string;
  glazeName: string;
  finishName: string;
  orderQty: number;
  boxUnit: string;
}

interface PDMopsMaterialDetail {
  id: string;
  proderNo: string;
  groupDescription: string;
  materialCode: string;
  materialName: string;
  brand: string;
  size: string;
  qty: string;
  totalQty: string;
  unit: string;
  purchaseQty: string;
  purchase_unit: string;
}

export interface PDMopsPOGroupHeader {
  pono: string;
  details: PDMopsPOGroupDetail[];
}

export interface PDMopsPOGroupDetail {
  id: string;
  proderNo: string;
  setPackingNo: string;
  skuDescription: string;
  skuNumber: string;
  size: string;
  glazeName: string;
  finishName: string;
  orderQty: number;
  boxUnit: string;
}
